import {cModal} from "./c-modal-new";
import {FastMessage} from "./fastmessages-new";
import {Frontend} from "./frontend-new";

export const addToOrder = (id_product, count, simple, setProducts, price) => {
    cModal.open("Dodaję produkt do koszyka", Frontend.GetLoadingHtml());
    const ajaxSettings = {
        dataType: 'json',
        success: function (data) {
            if (typeof data.error != 'undefined') {
                cModal.close();
                FastMessage.createMessage(data.error,FastMessage.error);
            } else {
                if (simple) {
                    FastMessage.createMessage(data.message);
                } else {
                    cModal.open("Produkt został dodany do koszyka", data.dialog);
                }
                if('freeItemMessage' in data){
                    FastMessage.createMessage(data.freeItemMessage.message, data.freeItemMessage.type);
                }
                $('.BasketBox').html(data.basket);
                if(typeof fbq != "undefined") {
                    fbq('track', 'AddToCart', {
                        content_ids: [id_product],
                        content_type: 'product',
                        value: price,
                        currency: ACTUAL_CURRENCY
                    });
                }
                if('GA' in data){
                    gtag("event", "add_to_cart", {
                        send_to: GA4,
                        ...data.GA
                    });
                    gtag("event", "add_to_cart", {
                        send_to: GADS,
                        ...data.GA
                    });
                }
            }
        }
    }
    ajaxSettings.url = OrdersPresenter + 'add-product-to-order/';
    if(typeof setProducts != "undefined"){
        ajaxSettings.type = 'POST';
        ajaxSettings.data = {
            id_product: id_product,
            count: count,
            set_products: JSON.stringify(setProducts)
        };
    }else{
        ajaxSettings.url += '?id_product=' + id_product + '&count=' + count;
    }
    $.ajax(ajaxSettings);
}